import React, { useContext, useMemo, useState } from "react";
import MainButton from "./MainButton";
import { getMode } from "../../../utils/getMode";
import Text from "./Text";
import { Box, CircularProgress } from "@material-ui/core";
import { ProcessContext } from "../../../contexts/ProcessContext";

export const RedirectToMerchantButton = () => {
  const {
    state: { loan },
  } = useContext(ProcessContext);

  const [loading, setLoading] = useState(false);

  const isEmbedded = useMemo(() => {
    return getMode() === "embedded";
  }, []);

  const handleRedirect = () => {
    setLoading(true);

    window.parent.postMessage(
      { messageId: "redirectToMerchant", payload: { status: loan.status } },
      "*"
    );
  };

  if (!isEmbedded) {
    return null;
  }

  return (
    <MainButton disabled={loading} onClick={handleRedirect}>
      {loading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gridGap={8}
        >
          <CircularProgress size={16} color="inherit" />
          <Text tId="REDIRECTING_TO_MERCHANT" />
        </Box>
      ) : (
        <Text tId="RETURN_TO_MERCHANT" />
      )}
    </MainButton>
  );
};
